import React, { useContext } from "react"
import { PageContext } from "../../context/PageContext"
import useDatoMicrocopy from "../../hooks/useDatoMicrocopy"
import * as styles from "./Pagination.module.scss"

type PaginationProps = { page: number; pageSize: number; totalElements: number; onNextPage: () => void }

const Pagination = (props: PaginationProps) => {
  //console.log('Rendering Pagination', props)
  const { locale } = useContext(PageContext)
  const t = useDatoMicrocopy("common", locale)
  const page = props.page
  const pageSize = props.pageSize
  const totalElements = props.totalElements

  const totalPages = Math.ceil(totalElements / pageSize)

  return (
    <div style={{ textAlign: "center" }}>
      {page < totalPages - 1 && (
        <>
          <p>
            {Math.min((page + 1) * pageSize, totalElements)}&nbsp;/&nbsp;{totalElements}
          </p>
          <button className={styles.nextButton} style={{ display: "inline-block" }} onClick={() => props.onNextPage()}>
            {t("showMore", "Show more")}
          </button>
        </>
      )}
    </div>
  )
}

export default Pagination
